/**
 * This file is part of the Haiman.
 * @link     : https://haiman.io/
 * @author   : Emil Zhai (root@derzh.com)
 * @modifier : Emil Zhai (root@derzh.com)
 * @copyright: Copyright (c) 2018 Hangzhou Haila Network Technology Co., Ltd.
 */

import http from './driver';
import { AdminPointLog, AdminCoinLog, AdminPayment } from './types/logger';

// 积分变动
export const getAdminPointLogs = (point, limit, kw) =>
  http.get<AdminPointLog>('admin/point-logs', { point, limit, kw });
// 海鳗币变动
export const getAdminCoinLogs = (point, limit, kw) =>
  http.get<AdminCoinLog>('admin/coin-logs', { point, limit, kw });
// 充值订单记录
export const getAdminPayLogs = (point, limit, kw) =>
  http.get<AdminPayment>('admin/pay-orders', { point, limit, kw });
